// extracted by mini-css-extract-plugin
export default {"dashboard-container":"Dashboard_dashboard-container__9oG9K"};